import { render, staticRenderFns } from "./RelatedLink.vue?vue&type=template&id=80e07270&scoped=true"
import script from "./RelatedLink.vue?vue&type=script&lang=js"
export * from "./RelatedLink.vue?vue&type=script&lang=js"
import style0 from "./RelatedLink.vue?vue&type=style&index=0&id=80e07270&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80e07270",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('80e07270')) {
      api.createRecord('80e07270', component.options)
    } else {
      api.reload('80e07270', component.options)
    }
    module.hot.accept("./RelatedLink.vue?vue&type=template&id=80e07270&scoped=true", function () {
      api.rerender('80e07270', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/RelatedLink.vue"
export default component.exports